import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
//import { createGtm } from '@gtm-support/vue-gtm'
import App from './App.vue'
import router from './router'
import store from './store'
//import { initAuthChannel } from '@/services/AuthChannelService'

import './assets/css/main.css'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsCallout from '@/components/DocsCallout'
import SoftUIDashboard from './soft-ui-dashboard'

function getIgnoreRoutes(routes) {
  for (let route of routes) {
    if ('name' in route) {
      if (route.name != 'Register' && route.name != 'RegisterSuccess')
        ignoreRoutes.push(route.name)
    }
    if ('children' in route) {
      getIgnoreRoutes(route.children)
    }
  }
}

let ignoreRoutes = []
getIgnoreRoutes(router.options.routes)

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
//initAuthChannel()
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(SoftUIDashboard)

// app.use(VueHtml2Canvas)
//if (location.hostname === 'mi-chao.com') {
//  app.use(
//    createGtm({
//      id: 'GTM-KFSC7LW', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//      defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
//      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
//      nonce: '2726c7f26d', // Will add `nonce` to the script tag
//      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//      debug: true, // Whether or not display console logs debugs (optional)
//      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//      ignoredViews: ignoreRoutes, // Don't trigger events for specified router names (case insensitive) (optional)
//      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
//    }),
//  )
//}
// --- GA4タグをheadに追加 ---
const script = document.createElement('script')
script.async = true
script.src = 'https://www.googletagmanager.com/gtag/js?id=G-YR96MDD8JP'
document.head.appendChild(script)

window.dataLayer = window.dataLayer || []
function gtag() {
  window.dataLayer.push(arguments)
}
window.gtag = gtag

gtag('js', new Date())
gtag('config', 'G-YR96MDD8JP', { send_page_view: false })
// ← send_page_viewをfalseにして、自動計測を切るのがポイント

// --- ページ遷移ごとにPVを送信 ---
router.afterEach((to) => {
  // /saml2/callback/ を含む場合はGA送信しない
  if (to.fullPath.startsWith('/saml2/callback')) {
    return
  }
  gtag('config', 'G-YR96MDD8JP', {
    page_path: to.fullPath,
  })
})

app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsCallout', DocsCallout)
// app.component('DocsExample', DocsExample)

app.mount('#app')
